/*
 * @Author: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @Date: 2023-11-15 14:18:08
 * @LastEditors: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @LastEditTime: 2023-11-15 16:32:16
 * @FilePath: \合联\oms\src\view\double\list\print.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export function printData(data) {
  if (data.src[0]) data.src[0] = data.src[0].replace('https', 'http')
  if (data.src[1]) data.src[1] = data.src[1].replace('https', 'http')
  console.log('data :>> ', data);
  return `
  <!DOCTYPE html>
  <html>
    <head>
      <meta charset="utf-8">
      <title></title>
    </head>
    <body>
      <style type="text/css">
        *{
          padding:0;
          margin:0;
        }
        .tg {
          border-collapse: collapse;
          border-spacing: 0;
          width: 95%;
          height: auto;
        }
        tbody,tr{
          width: 100%;
        }
  
        .tg td {
          border-color: black;
          border-style: solid;
          border-width: 1px;
          font-size: 14px;
          overflow: hidden;
          padding: 10px 5px;
          text-align:center;
          white-space: pre-wrap;
        }
  
      </style>
      <h3 style="text-align:center;margin-bottom:10px">调账证明</h3>
      <table class="tg" style="table-layout:fixed">
        <colgroup>
            <col span="8" style="width: 12.5%;text-align:center" />
          </colgroup>
        <tbody>
          <tr>
            <td class="tg-0lax" colspan="2">客 户 账 户</td>
            <td class="tg-0lax" colspan="6">${data.customer}</td>
          </tr>
          <tr>
            <td class="tg-0lax" colspan="2">客 户 中 文 名</td>
            <td class="tg-0lax" colspan="6">${data.company}</td>
          </tr>
          <tr>
            <td class="tg-0lax" colspan="2">单&nbsp;&nbsp;号</td>
            <td class="tg-0lax" colspan="2">${data.airway_number}</td>
            <td class="tg-0lax">出库时间</td>
            <td class="tg-0lax" colspan="3">${data.outbound_time}</td>
          </tr>
          <tr>
            <td class="tg-0lax" colspan="2">申请调账日期</td>
            <td class="tg-0lax" colspan="6" style="text-align:left">${data.create_time}</td>
          </tr>
          <tr>
            <td class="tg-0lax" rowspan="2">调账前</td>
            <td class="tg-0lax">收款项目</td>
            <td class="tg-0lax" colspan="2">计费类型</td>
            <td class="tg-0lax" colspan="2">货币代码</td>
            <td class="tg-0lax" colspan="2">费用</td>
          </tr>
          <tr>
            <td class="tg-0lax">${data.front.expense_name}</td>
            <td class="tg-0lax" colspan="2">${data.front.unit_txt}</td>
            <td class="tg-0lax" colspan="2">${data.front.currency}</td>
            <td class="tg-0lax" colspan="2">${data.front.total_amount}</td>
          </tr>
          <tr>
            <td class="tg-0lax">调账后</td>
            <td class="tg-0lax">${data.after.expense_name}</td>
            <td class="tg-0lax" colspan="2">${data.after.unit_txt}</td>
            <td class="tg-0lax" colspan="2">${data.after.currency}</td>
            <td class="tg-0lax" colspan="2">${data.after.total_amount}</td>
          </tr>
          <tr>
            <td class="tg-0lax" colspan="2">调 账 原 因</td>
            <td class="tg-0lax" colspan="6" style="text-align:left">${data.cause}</td>
          </tr>
          <tr>
            <td class="tg-0lax" colspan="2">相 关 截 图</td>
            <td class="tg-0lax" colspan="3">
              ${data.src[0] ? `<img transcolor="#FFFFFF" src="${data.src[0]}" style="width: 100%;" alt="">` : '&nbsp;'}
            </td>
            <td class="tg-0lax" colspan="3">
            ${data.src[1] ? `<img transcolor="#FFFFFF" src="${data.src[1]}" style="width: 100%;" alt="">` : '&nbsp;'}
            </td>
          </tr>
          <tr>
            <td class="tg-0lax" colspan="2">操 作 账 户</td>
            <td class="tg-0lax" colspan="6">${data.realname}&nbsp;${data.sale}</td>
          </tr>
        </tbody>
      </table>
    </body>
  </html>
  
  
  `
}